/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import Button from 'gatsby-core-theme/src/components/atoms/button';
import { navigate } from '@reach/router';
import { FaChevronCircleRight } from '@react-icons/all-files/fa/FaChevronCircleRight';
import { FaCaretRight } from '@react-icons/all-files/fa/FaCaretRight';

import { translate, imagePrettyUrl } from 'gatsby-core-theme/src/helpers/getters';
import { Context } from '~context/TranslationsProvider';

import styles from './match-calendar.module.scss';

const MatchCalendar = ({ pageContext, type = '' }) => {
  const { page } = pageContext;
  const { translations } = useContext(Context) || {};
  const sport = page?.relation?.sport?.name;
  const schedule = type ? page?.relation?.schedule[type] : page?.relation?.schedule;
  let scheduleArray = [];

  if (schedule) {
    scheduleArray = Object.keys(schedule).map((key) => schedule[key]);
    for (let i = 0; i < scheduleArray.length; i += 1) {
      const matches = [];
      // create tournaments array
      const tournamentsArray = Object.keys(scheduleArray[i].tournaments).map(
        (key) => scheduleArray[i].tournaments[key]
      );
      // concat all events
      for (let j = 0; j < tournamentsArray.length; j += 1) {
        matches.push(...tournamentsArray[j].events);
      }
      // assign events to each day
      scheduleArray[i].events = matches;
    }
    // sort events by time
    for (let i = 0; i < scheduleArray.length; i += 1) {
      const { events } = scheduleArray[i];
      events.sort((a, b) => a.date.time.replace(':', '') - b.date.time.replace(':', ''));
    }
  }

  const [showAll, setShowAll] = useState(false);

  const showGamePageLiveStream = (target) => {
    navigate(`/${target}`);
  };

  return (
    <div className={styles.matchCalendar}>
      <div className={styles.calendarContainer}>
        <table className={`${styles[sport]} ${!showAll && styles.hideItems}`}>
          <thead>
            <tr>
              <th>{translate(translations, 'calendar_time', 'Time')}</th>
              <th>{translate(translations, 'calendar_match', 'Match')}</th>
              <th>{translate(translations, 'calendar_league', 'League')}</th>
              <th>{translate(translations, 'calendar_channel', 'Channel')}</th>
            </tr>
          </thead>
          <tbody>
            {scheduleArray.map((item) => (
              <React.Fragment key={item.id}>
                <tr key={item.id} className={styles.date}>
                  <td colSpan="4">
                    {type
                      ? `${item?.date?.day_number}. ${item?.date?.month}`
                      : `${item?.date?.day}  ${item?.date?.day_number}. ${item?.date?.month_short}`}
                  </td>
                </tr>
                {item.events.map((event) => (
                  <tr
                    key={event.id}
                    className={styles.clickable}
                    onClick={() => showGamePageLiveStream(event?.path)}
                  >
                    <td>{event?.date?.time}</td>
                    <td>{`${event?.home_team?.name} V ${event?.away_team?.name}`}</td>
                    <td>{event?.tournament?.name}</td>
                    <td>
                      <div className={styles.imgs}>
                        {event.providers.map((provider) => (
                          <LazyImage
                            key={provider.id}
                            src={imagePrettyUrl(provider.square_logo)}
                            alt={provider.name}
                            width={34}
                            height={34}
                          />
                        ))}

                        <FaCaretRight />
                      </div>
                    </td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
      {!showAll && scheduleArray.length > 0 && (
        <Button
          isButton
          className={sport || 'soccer'}
          onClick={() => setShowAll(true)}
          btnText={
            <>
              <FaChevronCircleRight />
              {` ${translate(translations, 'view_full_schedule', 'View Full Schedule')}`}
            </>
          }
          gtmClass="match-calendar-gtm btn-cta"
        />
      )}
    </div>
  );
};

MatchCalendar.propTypes = {
  pageContext: PropTypes.shape({
    page: PropTypes.shape({
      path: PropTypes.string,
      relation: PropTypes.shape({}),
    }),
  }).isRequired,
  type: PropTypes.string,
};

export default MatchCalendar;
